"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const auth_events_1 = __importDefault(require("./auth.events"));
class AuthInterceptor {
  static getToken(bootstrap) {
    return __awaiter(this, void 0, void 0, function* () {
      let user = yield bootstrap.authService.getUser();
      if (user && !user.expired) return user.access_token;
      if (!user || (user === null || user === void 0 ? void 0 : user.expired) && this.isRenewing) {
        return new Promise(resolve => {
          const listen = user => {
            resolve(user.access_token);
            auth_events_1.default.removeListenUser(listen);
          };
          auth_events_1.default.addListenUser(listen);
        });
      }
      AuthInterceptor.isRenewing = true;
      user = yield bootstrap.getUser();
      AuthInterceptor.isRenewing = false;
      return user.access_token;
    });
  }
}
exports.default = AuthInterceptor;
AuthInterceptor.isRenewing = false;